import { useQuery, UseQueryResult } from '@tanstack/react-query';
import {IndexFundPriceHistory} from "@/integrations/supabase/indexfunds.models.ts";
import indexFundsService from "@indexFundsService";

export function useFetchIndexFundPriceHistory(
  fundSymbol: string,
  period: TimeRange
): UseQueryResult<IndexFundPriceHistory[]> {
  return useQuery({
    queryKey: ['index-fund-price-history', fundSymbol, period],
    queryFn: async () => {
      return await indexFundsService.fetchIndexFundPriceHistory({fundSymbol, period});
    },
    enabled: !!fundSymbol,
  });
}
